import SignUpCard from "../components/pageParts/auth/SingUpCard";


export default function SingUp() {
    return <SignUpCard />
}
